<template>
  <div class="coupon-list px-5 pt-6 pb-10 sm:px-0 sm:pb-6 sm:bg-gray-20 md:px-5 md:bg-gray-10" :class="list.length === 0 ? 'bg-gray-20' : 'bg-gray-10'">
    <div v-if="list.length > 0" class="grid grid-cols-1 gap-x-6 gap-y-2 lg:grid-cols-2 lg:gap-y-3">
      <component :is="couponCardComponent" v-for="item in list" :key="item.id" :item="item" />
    </div>
    <member-loading-state v-else-if="props.isPromoCodesLoading" />
    <list-no-result v-else class="<md:h-252px">
      <span class="whitespace-pre-line">{{ emptyListText }}</span>
    </list-no-result>
  </div>
</template>

<script setup lang="ts">
import ActiveCouponCard from '@/components/member/coupons/active-coupon-card.vue'
import InactiveCouponCard from '@/components/member/coupons/inactive-coupon-card.vue'
import MemberLoadingState from '@/components/member/member-loading-state.vue'
import ListNoResult from '@/components/common/list-no-result.vue'

import type { FpromoMemberPromoCode } from '@/types/api'

interface Props {
  type: 'active' | 'inactive'
  isPromoCodesLoading: boolean
  list?: FpromoMemberPromoCode[]
}

const { t } = useI18n()

const props = withDefaults(defineProps<Props>(), { list: () => [] as FpromoMemberPromoCode[] })

const couponCardComponent = computed(() => (props.type === 'active' ? ActiveCouponCard : InactiveCouponCard))
const emptyListText = computed(() => (props.type === 'active' ? t('promo.list_empty') : t('promo.expired.empty')))
</script>
